export default {
  allWeek: 'Celý týždeň',
  allDay: 'Celý deň',
  noDays: 'Nie sú vybrané žiadne dni',
};
